import { h, resolveComponent, cloneVNode, Fragment } from 'vue';
import {
  addSafeEventListener,
  removeSafeEventListener,
} from 'dashboard/helper/domEvents';

const flattenSlotChildren = (children) =>
  children.flatMap((node) => {
    if (node?.type === Fragment && Array.isArray(node.children)) {
      return flattenSlotChildren(node.children);
    }
    return node ? [node] : [];
  });

export default {
  name: 'OtelloTabs',
  props: {
    index: {
      type: Number,
      default: 0,
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return { hasScroll: false };
  },
  created() {
    const windowObject = typeof window !== 'undefined' ? window : null;
    addSafeEventListener(windowObject, 'resize', this.computeScrollWidth);
  },
  beforeUnmount() {
    const windowObject = typeof window !== 'undefined' ? window : null;
    removeSafeEventListener(windowObject, 'resize', this.computeScrollWidth);
  },
  mounted() {
    this.computeScrollWidth();
  },
  methods: {
    computeScrollWidth() {
      const tabElement = this.$el.getElementsByClassName('tabs')[0];
      this.hasScroll = tabElement.scrollWidth > tabElement.clientWidth;
    },
    onScrollClick(direction) {
      const tabElement = this.$el.getElementsByClassName('tabs')[0];
      let scrollPosition = tabElement.scrollLeft;
      if (direction === 'left') {
        scrollPosition -= 100;
      } else {
        scrollPosition += 100;
      }
      tabElement.scrollTo({
        top: 0,
        left: scrollPosition,
        behavior: 'smooth',
      });
    },
    createScrollButton(direction) {
      if (!this.hasScroll) {
        return null;
      }
      const FluentIcon = resolveComponent('fluent-icon');
      return h(
        'button',
        {
          class: 'tabs--scroll-button button clear secondary button--only-icon',
          onClick: () => this.onScrollClick(direction),
        },
        [h(FluentIcon, { icon: `chevron-${direction}`, size: 16 })]
      );
    },
  },
  // Vue 3 render: $slots.default is a function returning the children;
  // slotted <otello-tabs-item> vnodes are identified by their component
  // `type.name` (Vue 3 vnode shape) and the active index is injected via
  // cloneVNode (vnode props must not be mutated in place).
  render() {
    const slotChildren = this.$slots.default ? this.$slots.default() : [];
    const tabs = flattenSlotChildren(slotChildren)
      .filter((node) => node.type && node.type.name === 'OtelloTabsItem')
      .map((node, index) => cloneVNode(node, { index }));
    const leftButton = this.createScrollButton('left');
    const rightButton = this.createScrollButton('right');
    return h(
      'div',
      {
        class: {
          'tabs--container--with-border': this.border,
          'tabs--container': true,
        },
      },
      [
        leftButton,
        h(
          'ul',
          { class: { tabs: true, 'tabs--with-scroll': this.hasScroll } },
          tabs
        ),
        rightButton,
      ]
    );
  },
};
